// @flow
export function getPhoneNumberUnmasked (maskedPhone: string): string {
  if (maskedPhone === "") { return "" }
  const matchedPhoneElements = maskedPhone.match(/\d+/g);
  if (matchedPhoneElements) {
    return matchedPhoneElements.map(Number).join("");
  } else {
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/Utilities/Helpers/InputMaskHelpers.js